<template>
	<div>
		<el-card shadow="none">
			<h2 style="position: relative; left: 10%">
				{{ storeObj.action == "CREATE" ? "Create" : "Edit" }} Task
			</h2>
			<div style="margin-top: 30px">
				<el-row>
					<el-col :span="12" :offset="3">
						<div>Task Title</div>
						<el-input
							type="text"
							v-model="title"
							placeholder="Enter Task Title"
							class="input-class"
							v-validate="'required'"
							name="Enter Task Title"
							style="margin-top: 10px"
						/>
						<p>
							<span
								:v-show="errors.has(`Enter Task Title`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Enter Task Title`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row style="margin-top: 25px">
					<el-col :span="12" :offset="3">
						<div>Task Type</div>
						<div style="display: flex; margin-top: 10px">
							<el-radio v-model="task_type" label="Yes / No"
								>Select Yes / No
							</el-radio>
							<el-radio v-model="task_type" label="Long text"
								>Add Comment
							</el-radio>
							<el-radio v-model="task_type" label="Photo"
								>Upload Photo
							</el-radio>
							<el-radio v-model="task_type" label="form">Select Form </el-radio>
						</div>
					</el-col>
				</el-row>
				<el-row v-if="task_type == 'form'">
					<el-col :span="12" :offset="3">
						<div style="margin-top: 25px">Select Form</div>
						<el-select
							class="select"
							v-model="form"
							filterable
							placeholder="Select Form"
							v-validate="'required'"
							name="Select Form"
							style="text-transform: capitalize; margin-top: 10px"
						>
							<el-option
								v-for="item in formItems"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Select Form`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Select Form`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row style="margin-top: 25px">
					<el-col :span="12" :offset="3">
						<div>Description (optional)</div>
						<el-input
							type="textarea"
							v-model="description"
							placeholder="Description"
							class="input-class"
							style="text-transform: capitalize; margin-top: 10px"
							:rows="4"
						/>
					</el-col>
				</el-row>
				<el-row style="margin-top: 25px">
					<el-col :span="3" :offset="3">Attach Media</el-col>
					<el-col :span="12">
						<el-button
							class="button-class-white"
							icon="el-icon-upload"
							@click="$refs.fileUploadSelector.click()"
						>
							Upload
						</el-button>
						<div style="font-size: 12px; margin-top: 5px; color: #d26300">
							Supported media : JPG, JPEG, PNG, and PDF
						</div>
						<input
							type="file"
							ref="fileUploadSelector"
							id="fileInput"
							accept=".jpeg, .jpg, .png, .pdf, .gif, .csv, .webp, .vnd.openxmlformats-officedocument.spreadsheetml.sheet, .vnd.ms-excel, .mp4, .mov, .wmv, .avi, .avchd, .flv, .f4v, .swf, .mkv, .webm, .mpg, .mp2, .mpeg, .mpe, .mpv"
							@change="upload_file_handler"
							style="display: none"
							multiple
						/>
					</el-col>
				</el-row>
				<el-row style="margin-top: 10px" v-if="fileURLArray">
					<el-col
						style="margin-right: 20px"
						v-for="(item, idx) in fileURLArray"
						:key="idx"
						:span="1"
						:offset="idx == 0 ? 3 : 0"
					>
						<div style="cursor: pointer">
							<el-tooltip
								class="item"
								v-if="
									item.fileDetails.type.includes('image') ||
									item.fileDetails.type.includes('jpg') ||
									item.fileDetails.type.includes('jpeg') ||
									item.fileDetails.type.includes('png') ||
									item.fileDetails.type.includes('gif') ||
									item.fileDetails.type.includes('bmp') ||
									item.fileDetails.type.includes('webp')
								"
								effect="light"
								content="Click to show image"
								placement="bottom"
							>
								<img
									:src="item.src"
									@click="show_excel(item.src)"
									style="height: 50px"
								/>
							</el-tooltip>
							<el-tooltip
								class="item"
								v-if="
									item.fileDetails.type.includes('mp4') ||
									item.fileDetails.type.includes('mov') ||
									item.fileDetails.type.includes('wmv') ||
									item.fileDetails.type.includes('avi') ||
									item.fileDetails.type.includes('avchd') ||
									item.fileDetails.type.includes('flv') ||
									item.fileDetails.type.includes('f4v') ||
									item.fileDetails.type.includes('swf') ||
									item.fileDetails.type.includes('mkv') ||
									item.fileDetails.type.includes('webm') ||
									item.fileDetails.type.includes('mpg') ||
									item.fileDetails.type.includes('mp2') ||
									item.fileDetails.type.includes('mpeg') ||
									item.fileDetails.type.includes('mpe') ||
									item.fileDetails.type.includes('mpv') ||
									item.fileDetails.type.includes('video')
								"
								effect="light"
								content="Click to show image"
								placement="bottom"
							>
								<video
									:src="item.src"
									@click="show_excel(item.src)"
									style="height: 50px"
								/>
							</el-tooltip>
							<el-tooltip
								v-if="item.fileDetails.type.includes('pdf')"
								class="item"
								effect="light"
								content="Click to show pdf"
								placement="bottom"
							>
								<img
									style="height: 50px"
									@click="show_excel(item.src)"
									src="../../../../assets/icons/pdf.png"
								/>
							</el-tooltip>
							<el-tooltip
								v-if="
									item.fileDetails.type.includes('csv') ||
									item.fileDetails.type.includes('sheet')
								"
								class="item"
								effect="light"
								content="Click to show excel"
								placement="bottom"
							>
								<img
									style="height: 50px"
									@click="show_excel(item.src)"
									src="../../../../assets/icons/excel.png"
								/>
							</el-tooltip>
							<div class="text-right">
								<i @click="delete_file_list(item)" class="el-icon-delete" />
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6" :offset="3">
						<div style="margin-top: 25px">Start Date</div>
						<el-date-picker
							style="margin-top: 10px; width: 95%"
							v-model="start_date"
							type="date"
							placeholder="Select Date"
							class="date"
							format="dd-MMM-yyyy"
							:picker-options="datePickerOptions"
							v-validate="'required'"
							name="Issue Date"
						>
						</el-date-picker>
						<p>
							<span
								:v-show="errors.has(`Issue Date`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Issue Date`) ? "This field is required" : "" }}
							</span>
						</p>
					</el-col>
					<el-col :span="6" :offset="0">
						<div style="margin-top: 25px">End Date</div>
						<el-date-picker
							style="margin-top: 10px; width: 100%"
							v-model="end_date"
							type="date"
							placeholder="Select Date"
							class="date"
							format="dd-MMM-yyyy"
							:picker-options="fromDatePickerOptions"
							v-validate="'required'"
							name="Expiry Date"
						>
						</el-date-picker>
						<p>
							<span
								:v-show="errors.has(`Expiry Date`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Expiry Date`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12" :offset="3">
						<div style="margin-top: 25px">Locations</div>
						<el-select
							class="select"
							v-model="location"
							filterable
							placeholder="Select Locations"
							:multiple="true"
							:clearable="true"
							:collapse-tags="true"
							v-validate="'required'"
							name="Select Location"
							style="text-transform: capitalize; margin-top: 10px"
						>
							<el-row style="height: 30px" :gutter="5">
								<el-col :span="12"
									><div
										@click="select_all('location')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Select All
									</div></el-col
								>
								<el-col :span="12"
									><div
										@click="clear_all('location')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Clear All
									</div></el-col
								>
							</el-row>
							<el-option
								v-for="item in locationItems"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Select Location`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Select Location`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row style="margin-top: 30px">
					<el-col :span="2" :offset="3">
						<div>Assign By</div>
					</el-col>
					<el-col :span="3" :offset="1">
						<el-radio v-model="filter_by" label="designation"
							>Designation
						</el-radio>
					</el-col>
					<el-col :span="2" :offset="0">
						<el-radio v-model="filter_by" label="user">Users </el-radio>
					</el-col>
				</el-row>
				<el-row style="margin-top: 30px">
					<el-col :span="6" :offset="3">
						<div>Designation</div>
						<el-select
							class="select"
							v-model="designations"
							filterable
							:multiple="true"
							:clearable="true"
							placeholder="Select Designation"
							v-validate="'required'"
							name="Renewal Select Designation"
							style="margin-top: 10px; width:95%"
							@input="
								filter_by == 'user'
									? getUsersListByDesignation(designations)
									: ''
							"
							:collapse-tags="true"
							ref="designations"
						>
							<el-row style="height: 30px" :gutter="5">
								<el-col :span="12"
									><div
										@click="select_all('designations')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Select All
									</div></el-col
								>
								<el-col :span="12"
									><div
										@click="clear_all('designations')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Clear All
									</div></el-col
								>
							</el-row>
							<el-option
								v-for="(item, key) in designations_list"
								:key="key"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Renewal Select Designation`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Renewal Select Designation`)
										? "This field is required"
										: ""
								}}
							</span>
						</p>
					</el-col>
					<el-col :span="6" :offset="0">
						<div v-if="filter_by == 'user'">User</div>
						<el-select
							class="select"
							v-model="user"
							filterable
							:multiple="true"
							:clearable="true"
							placeholder="Select User"
							v-if="filter_by == 'user'"
							v-validate="'required'"
							name="Select User"
							:collapse-tags="true"
							style="margin-top: 10px"
						>
							<el-row style="height: 30px" :gutter="5">
								<el-col :span="12"
									><div
										@click="select_all('user')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Select All
									</div></el-col
								>
								<el-col :span="12"
									><div
										@click="clear_all('user')"
										style="cursor: pointer; color: #d26300; text-align: center"
									>
										Clear All
									</div></el-col
								>
							</el-row>
							<el-option
								v-for="(item, key) in users_list"
								:key="key"
								:label="item.full_name"
								:value="item.id"
							>
							</el-option>
						</el-select>
						<p>
							<span
								:v-show="errors.has(`Select User`)"
								class="text-red-dark text-xs"
							>
								{{
									errors.first(`Select User`) ? "This field is required" : ""
								}}
							</span>
						</p>
					</el-col>
				</el-row>
				<el-row style="margin-top: 30px">
					<el-col :span="1" :offset="18">
						<el-button
							class="button-class-white"
							style="border: none"
							@click="$emit('close')"
						>
							Cancel
						</el-button>
					</el-col>
					<el-col style="margin-bottom: 40px" :span="1" :offset="1">
						<el-button class="button-class" @click="create_task()">
							Create
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-card>
	</div>
</template>
<script>
import formBuilderServices from "../../../../services/formBuilderServices";
import licenseManagementService from "../../../../services/licenseManagementService";
var moment = require("moment");
// quick_task 2064 show_active_project = false
export default {
	props: {
		active_view: String,
		storeObj: Object,
	},
	data: () => ({
		title: "",
		task_type: "Yes / No",
		form: "",
		formItems: [],
		description: "",
		start_date: "",
		end_date: "",
		datePickerOptions: {
			firstDayOfWeek: 1,
		},
		fileURLArray: [],
		location: "",
		locationItems: [],
		filter_by: "designation",
		designations: [],
		designations_list: [],
		user: [],
		users_list: [],
		inputTypeItems: [],
		uploadedAttachments: [],
	}),
	computed: {
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: (date) => {
					// const currentDate = new Date();
					// if (date < currentDate) {
					// 	return true;
					// }
					if (this.start_date) {
						return date < this.start_date;
					}
					return false;
				},
			};
		},
	},
	mounted() {
		this.list_all_input_types();
		this.list_forms();
		this.get_location_list();
		this.getDesignationsList();
	},
	methods: {
		call_task_api() {
			let uploadedAttachments = [];
			if (this.uploadedAttachments.length > 0) {
				for (let i = 0; i < this.uploadedAttachments.length; i++) {
					uploadedAttachments.push({
						file_name: this.uploadedAttachments[i].file_name,
						file_path: this.uploadedAttachments[i].file_path,
					});
				}
			}
			let count = [...this.fileURLArray].filter((el) => el.id);
			if (count.length > 0) {
				for (let i = 0; i < count.length; i++) {
					uploadedAttachments.push({
						id: count[i].id,
						file_name: count[i].file_name,
						file_path: count[i].file_path,
					});
				}
			}
			let start_date = moment(this.start_date).format("YYYY-MM-DD");
			let end_date = moment(this.end_date).format("YYYY-MM-DD");

			let inputType = this.inputTypeItems.find(
				(el) => el.name === this.task_type && this.task_type !== "form"
			);
			let inputTypeId = inputType ? inputType.id : '';
			let params = {
				input_type: inputTypeId,
				task_title: this.title,
				form: this.form,
				attachments: uploadedAttachments,
				start_date: start_date,
				end_date: end_date,
				designations: this.designations,
				users: this.user,
				filters: {
					outlets: this.location,
				},
				assign_to: this.filter_by,
			};
			formBuilderServices
				.createQuickTask(params)
				.then((res) => {
					console.log(res, "rrrrrrrrrrrrrpes");
					this.$notify.success({
						title: "Success",
						message: "Quick Task Created Successfully",
						type: "Success",
					});
					this.$emit("close");
				})
				.catch((err) => {
					if (err.response) {
						this.$notify.error({
							title: "Fail",
							message: `${JSON.parse(err.response.data).msg}`,
						});
					}
				});
		},
		create_task() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.fileURLArray.length > 0) {
						this.upload_question_attachments_api();
					} else {
						this.call_task_api();
					}
				}
			});
		},
		upload_question_attachments_api() {
			let count = [...this.fileURLArray].filter((el) => !el.id);
			if (count.length > 0) {
				const formData = new FormData();
				const fetchAndConvertToFile = async (url) => {
					try {
						if (url && typeof url === "object" && url.src) {
							const response = await fetch(url.src);
							const blob = await response.blob();
							const fileName = url.fileDetails.name;
							return new File([blob], fileName);
						} else {
							throw new Error("Invalid URL format");
						}
					} catch (error) {
						console.error("Error fetching or processing file:", error);
						throw error;
					}
				};
				const uploadPromises = [...this.fileURLArray]
					.filter((el) => !el.id)
					.map(async (url, index) => {
						try {
							const file = await fetchAndConvertToFile(url);
							formData.append("attachments", file);
						} catch (error) {
							console.error(
								`Error at index ${index} during file processing:`,
								error
							);
						}
					});
				Promise.all(uploadPromises)
					.then(() => {
						formBuilderServices
							.uploadQuestionAttachment(formData)
							.then((res) => {
								this.uploadedAttachments = JSON.parse(res.data).data;
								this.call_task_api();
							});
					})
					.catch((error) => {
						console.error("Error during file processing:", error);
					});
			} else {
				this.call_task_api();
			}
		},
		select_all(type, idx) {
			switch (type) {
				case "designations":
					let designation = [];
					for (let i = 0; i < this.designations_list.length; i++) {
						designation.push(this.designations_list[i].id);
					}
					this.designations = designation;
					this.$nextTick(() => {
						this.$refs.designations.$emit("input", this.designations);
					});
					this.$forceUpdate();
					break;
				case "user":
					let users_list = [];
					for (let i = 0; i < this.users_list.length; i++) {
						users_list.push(this.users_list[i].id);
					}
					this.user = users_list;
					this.$forceUpdate();
					break;
				case "location":
					let locationItems = [];
					for (let i = 0; i < this.locationItems.length; i++) {
						locationItems.push(this.locationItems[i].id);
					}
					this.location = locationItems;
					this.$forceUpdate();
					break;
			}
		},
		clear_all(type, idx) {
			switch (type) {
				case "designations":
					let designations = [];
					this.designations = designations;
					this.$nextTick(() => {
						this.$refs.designations.$emit("input", this.designations);
					});
					this.$forceUpdate();
					break;
				case "user":
					let user = [];
					this.user = user;
					this.$forceUpdate();
					break;
				case "location":
					let location = [];
					this.location = location;
					this.$forceUpdate();
					break;
			}
		},
		getDesignationsList() {
			licenseManagementService.fetchAllDesignations().then((res) => {
				this.designations_list = JSON.parse(res.data);
			});
		},
		getUsersListByDesignation(designations) {
			this.users_list = [];
			let params = {
				designations: designations,
				store: null,
				user_groups: [],
			};
			licenseManagementService
				.fetchAllUsersByDesignations(params)
				.then((res) => {
					this.users_list = JSON.parse(res.data);
				});
		},
		get_location_list() {
			formBuilderServices.listAllLocations().then((res) => {
				let locationItems = JSON.parse(res.data);
				this.locationItems = locationItems.sort((a, b) =>
					a.name < b.name ? -1 : 1
				);
			});
		},
		list_forms() {
			this.formItems = [];
			formBuilderServices
				.listTasks()
				.then((res) => {
					this.formItems = JSON.parse(res.data);
				})
				.catch(() => {
					this.isloading = false;
				});
		},
		list_all_input_types() {
			this.inputTypeItems = [];
			formBuilderServices.listInputTypes().then((res) => {
				this.inputTypeItems = JSON.parse(res.data);
			});
		},
		upload_file_handler(event) {
			const fileInput = event.target; // Accessing the input element from the event
			const files = Array.from(fileInput.files);
			if (files.length > 5) {
				alert("Please select up to 5 files only.");
				return;
			}
			files.forEach((file) => {
				const indexToRemove = this.fileURLArray.findIndex(
					(uploadedFile) => uploadedFile.fileDetails.name === file.name
				);
				if (indexToRemove !== -1) {
					this.fileURLArray.splice(indexToRemove, 1);
				}
			});
			this.fileURLArray = this.fileURLArray.concat(
				files.map((file) => ({
					fileDetails: file,
					src: URL.createObjectURL(file),
				}))
			);
		},
		delete_file_list(item) {
			const indexToRemove = this.fileURLArray.findIndex(
				(file) => file.fileDetails.name === item.fileDetails.name
			);
			if (indexToRemove !== -1) {
				this.fileURLArray.splice(indexToRemove, 1);
			}
			const fileInput = this.$refs.fileUploadSelector;
			fileInput.value = null;
			this.$notify.success({
				title: "Success",
				message: "Attachment Deleted Successfully",
				type: "Success",
			});
		},
		show_excel(excel) {
			window.open(excel);
		},
	},
};
</script>
